<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
          <span class="search_span_width">
	  				<span class="search_span_width_part1">人物ID：</span>
            <Input v-model="search.figure_id" placeholder="请输入人物id" style="width: 200px" />
	        </span>
          <span class="search_span_width">
	  				<span class="search_span_width_part1">卡号：</span>
            <Input v-model="search.nfc_no" placeholder="请输入卡号" style="width: 200px" />
	        </span>
          <span class="search_span_width">
	  				<span class="search_span_width_part1">人物名字：</span>
            <Input v-model="search.name" placeholder="请输入人物名字" style="width: 200px" />
	        </span>
          <span class="search_span_width">
              <span class="search_span_width_part1">是否绑定：</span>
              <Select v-model="search.is_bind" style="width:200px">
                  <Option value="" >全部</Option>
                  <Option value="1" >是</Option>
                  <Option value="2" >否</Option>
              </Select>
          </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getUserNfcList(1)">搜索</Button>
        <Button type='primary' icon="md-add" :style="{'margin-left':'20px'}" @click="handdleAdd()">新增</Button>
        <Button type='primary'  :style="{'margin-left':'20px'}" @click="handleCommonQrCode()">通用二维码</Button>
      </Card>
      <Card id="tableContent" >
        <Table :columns="tableColumns" :data="user_nfc_list"></Table>
        <Page :total="total" :current="search.page" :page-size=search.pageSize :show-elevator="true" @on-change="getUserNfcList"/>
      </Card>
      <Modal
          v-model="showEdit"
          title="编辑"
          footer-hide>
        <Form ref="agent" :model="editForm" :label-width="80"  >
          <FormItem label="卡号">
            <Input  v-model="editForm.nfc_no" style="width: 300px;"/>
          </FormItem>
          <FormItem label="NFC码">
            <Input  v-model="editForm.openlink" style="width: 300px;"/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="update()">提交</Button>
          </FormItem>
        </Form>
      </Modal>
      <Modal
          v-model="showVideo"
          title="视频"
         >
          <video :src="playForm.video" v-if="playForm.video" width="66%"  controls />
          <span v-else>暂无可播放资源</span>
        <template #footer>
          <Button type="success"   @click="recreate">重新生成</Button>
        </template>
      </Modal>
      <Modal v-model="showQrCode" width="250" footer-hide>
        <img :src="qrcode" width="200px;">
      </Modal>
      <Modal v-model="showCommonQrCode" width="250" footer-hide>
        <img :src="commonQrcode" width="200px;">
      </Modal>
      <Modal
          v-model="showAdd"
          title="新增"
          footer-hide>
        <Form ref="agent" :model="addForm" :label-width="80"  >
          <FormItem label="卡号">
            <Input  v-model="addForm.nfc_no" style="width: 300px;"/>
          </FormItem>
          <FormItem label="人物ID">
            <Input  v-model="addForm.figure_id" style="width: 300px;"/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="add()">提交</Button>
          </FormItem>
        </Form>
      </Modal>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      search:{
        page:1,
        pageSize: 10,
        mobile:"",
        figure_id:'',
        nfc_no:"",
        is_bind:'',
        name:""
      },
      editForm:{
        openlink:"",
        nfc_no:""
      },
      playForm:{
        video:"",
        figure_id:"",
        id:""
      },
      addForm:{
        video:"",
        figure_id:"",
        nfc_no:""
      },
      showTag: false,
      showVideo: false,
      showAdd: false,
      showQrCode: false,
      showCommonQrCode: false,
      loading2:false,
      total:20,
      showEdit:false,
      user_nfc_list:[],
      show:true,
      qrcode:"",
      commonQrcode:"",
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center' },
        { title: '卡号', key: 'nfc_no', align: 'center' },
        { title: '用户名', key: 'nickname', align: 'center' },
        { title: '人物ID', key: 'figure_id', align: 'center' },
        { title: '人物名称', key: 'title', align: 'center' },
        { title: '人物头像', key: 'thumb', align: 'center',render:(h,params)=>{
            return h('img',{
              attrs : {src : params.row.thumb},
              style : { width : '80px' }
            })
          }
        },
        { title: 'NFC码', key: 'openlink', align: 'center' },
        { title: '绑定时间', key: 'bind_at', align: 'center' },
        { title: '操作', key: 'action', align: 'center', width:100,
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button', {
                  props: { type: 'warning', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      // 清空editForm
                      this.editForm.id = params.row.id;
                      this.editForm.user_id = params.row.user_id;
                      this.editForm.nickname = params.row.nickname;
                      this.editForm.openlink = params.row.openlink;
                      this.editForm.nfc_no = params.row.nfc_no;
                      if(this.editForm.user_id){
                        this.showTag = true
                      }
                      this.showEdit = true;
                    }
                  }
                }, '编辑'),
            );
            btns.push(
                h('Button', {
                  props: { type: 'primary', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认',
                        content: '<p>确认重新生成小程序码？</p>',
                        onOk: () => {
                          this.createNfcUrl(params.row)
                        },
                        onCancel: () => {
                          this.$Message.info('已取消');
                        }
                      });
                    }
                  }
                }, '生成'),
            );
            btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.playForm = {}
                      this.playForm.video = params.row.video
                      this.playForm.id = params.row.id
                      this.playForm.figure_id = params.row.figure_id
                      this.showVideo = true
                    }
                  }
                }, '查看视频'),
            );
            btns.push(
                h('Button', {
                  props: { type: 'success', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.qrcode = ""
                      console.log(params.row.id)
                      this.getQrCode(params.row.id)
                      this.showQrCode = true;
                    }
                  }
                }, '二维码'),
            );
            return h("div",btns);
          }
        }
      ],
      user_list:[],
    }
  },
  mounted:function(){
    this.getUserNfcList();
  },
  computed:{

  },
  methods:{
    getUserNfcList(page=1) {
      if(page){
        this.search.page = page
      }
      this.http.get('/admin/user/getUserNfcList',{params:this.search}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.user_nfc_list = data.data.list;
          this.total = data.data.total

        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    update(){
      this.http.post('/admin/user/updateUserNfc',this.editForm).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.success(data.message);
          this.getUserNfcList(1)
          this.showEdit=false;
          return true;
        }
      });
    },
    handdleAdd(){
      this.addForm = {}
      this.showAdd=true;
    },
    add(){
      this.http.post('/admin/user/addUserNfc',this.addForm).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.success(data.message);
          this.getUserNfcList(1)
          this.showAdd=false;
          return true;
        }
      });
    },
    userList(query){
      if (query !== '' && query.length >=2) {
        this.loading3 = true;
        setTimeout(() => {
          this.loading3 = false;

          this.http1.get('/user/getUserSelectAll',{params:{nickname:query}}).then(response=>{
            let data=response.data;
            if(data.code!==0)
            {
              alert(data.message);
            } else{
              this.user_list = data.data;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });

        }, 200);
      }
    },
    handleClose(){
      this.showTag=false;
      this.editForm.user_id=""
    },
    createNfcUrl(row){

      if(!row.id || !row.nfc_no){
        this.$Message.error("请填写卡号");
        return
      }
      this.http.post('/admin/user/createNfcUrl',{id:row.id,nfc_no:row.nfc_no}).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.success(data.message);
          this.$Modal.confirm({
            title: '小程序码',
            content: data.data.url,
            onOk: () => {

            },
            onCancel: () => {

            }
          });
          this.getUserNfcList(1)
          this.showEdit=false;
          return true;
        }
      });
    },
    getQrCode(id){
      this.http.get('/admin/user/getNfcQrCode',{params:{id:id}}).then(response=>{
        let data=response.data;
        if(data.code!==0)
        {
          this.$Message.error(data.message);
        } else{
          this.qrcode = data.data.img_url
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    handleCommonQrCode(){
      this.showCommonQrCode = true;
      this.http.get('/admin/user/getNfcCommonQrCode').then(response=>{
        let data=response.data;
        if(data.code!==0)
        {
          this.$Message.error(data.message);
        } else{
          this.commonQrcode = data.data.img_url
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    recreate(){
      this.http.post('/admin/user/recreateVideo',this.playForm).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.success(data.message);
          return true;
        }
      });
    }
  }

}
</script>
